import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPartner } from '../service/partners/selector';
import PartnerContainer from './PartnerContainer';
import { I18n } from 'react-redux-i18n';
import ChildrenLink from '../Components/ChildrenLink';
import { getChildId } from '../../../Components/MasterBar/service/saga';

class Fullsoon extends Component {
	render() {
		const { partner } = this.props;

		return (
			<PartnerContainer
				name={I18n.t(`partner.prefix.${partner.prefix}`)}
				id={partner ? partner.id : null}
				prefix={partner ? partner.prefix : null}>
				<ChildrenLink prefix={partner ? partner.prefix : null} />

				{/* On affiche ca parce que le fulsoon n'a pas de config possible appart le children link en mode master - a enlever si on rajoute des options */}
				{!this.props.connectAsMaster && (
					<h3>
						Aucune option de configuration n'est disponible pour ce partenaire.
					</h3>
				)}
			</PartnerContainer>
		);
	}
}

const mapStateToProps = (state, props) => {
	const partner = getPartner(state, props);
	const connectAsMaster = state.service.user.children.length && !getChildId();
	return {
		partner,
		connectAsMaster,
	};
};

export default connect(mapStateToProps)(Fullsoon);
